import React, { FC } from "react"

import { IApiLink } from "@/types"
import { ApiLinkEntity } from "config/constants"
import Documents from "components/Documents/Documents"

interface IReservationDocumentsProps {
    reservationNumber: string,
    linkGetReservationDocuments?: IApiLink
    linkAddReservationDocuments?: IApiLink
}

const ReservationDocuments: FC<React.PropsWithChildren<IReservationDocumentsProps>> = ({
    reservationNumber,
    linkGetReservationDocuments,
    linkAddReservationDocuments,
}) => {
    return (
        <Documents
            entity={ApiLinkEntity.reservationDocument}
            linkGetDocuments={linkGetReservationDocuments}
            linkAddDocuments={linkAddReservationDocuments}
            withEmails={true}
            zipFileNameSuffix={reservationNumber}
        />
    )
}

export default ReservationDocuments
